import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { getPublishableApiKey } from '../../config/get-publishable-key';

export const medusaInterceptor: HttpInterceptorFn = (req, next) => {
  const newReq = req.clone({
    setHeaders: {
      'x-publishable-api-key': getPublishableApiKey(),
      'Content-Type': 'application/json',
    },
  });

  return next(newReq).pipe(
    catchError(error => throwError(() => error as HttpErrorResponse))
  );
};
